import React, {lazy} from 'react';
import {Route} from 'react-router-dom';


import * as buyConstants from '../buyConstants';

import RootRoutes from '../../../roots/RootRoutes';
import {contentConstants} from '../../../contexts/Content';

const BuyContentOverviewPage = lazy(() => import('./BuyContentOverviewPage'));
const ContentDetailPage = lazy(() => import('./ContentDetailPage'));
const SearchPage = lazy(() => import('./SearchPage'));


function Index() {

    return (
        <RootRoutes>

            <Route
                element={<BuyContentOverviewPage/>}
                exact={true}
                path={buyConstants.NAV_BUY_OVERVIEW_PAGE}
            />

            <Route
                element={<ContentDetailPage/>}
                exact={true}
                path={contentConstants.NAV_CONTENT_DETAIL_PAGE}
            />

            <Route
                element={<SearchPage/>}
                path={buyConstants.NAV_SEARCH_PAGE}
            />

        </RootRoutes>
    );
}


export default Index;
